module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-steps",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('mt-steps', {
    attrs: {
      "direction": "horizontal",
      "description": "",
      "title": "物流进度"
    }
  }, [_c('mt-step', {
    attrs: {
      "status": "finish"
    }
  }, [_vm._v("买家下单")]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": _vm.status
    }
  }, [_vm._v("商家接单")]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": "process"
    }
  }, [_vm._v("买家提货")]), _vm._v(" "), _c('mt-step', [_vm._v("交易完成")])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('mt-steps', {
    attrs: {
      "direction": "vertical",
      "description": "步骤的描述",
      "title": "物流进度"
    }
  }, [_c('mt-step', [_c('h3', [_vm._v("【城市】物流状态3")]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("12:40"), _c('br'), _vm._v("2016-07-12")])]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": _vm.status
    }
  }, [_c('h3', [_vm._v("【城市】物流状态2")]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("10:00"), _c('br'), _vm._v("2016-07-11")])]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": "process"
    }
  }, [_c('h3', [_vm._v("【南京】快件发往南京中转站")]), _vm._v(" "), _c('p', [_vm._v("快递发送中")]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("10:00"), _c('br'), _vm._v("2016-07-11")])]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": "finish"
    }
  }, [_c('h3', [_vm._v("【南京】快件已揽件")]), _vm._v(" "), _c('p', [_vm._v("快递中心已收件，等待发送快递中心；已收件，等待发送快递中心已收件，等待发送；快递中心已收件，等待发送")]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("09:30"), _c('br'), _vm._v("2016-07-10")])])], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('mt-steps', {
    attrs: {
      "direction": "vertical",
      "description": "步骤的描述",
      "padding-left": 70
    }
  }, [_c('mt-step', [_c('h3', [_vm._v("【城市】物流状态3")])]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": _vm.status
    }
  }, [_c('h3', [_vm._v("【城市】物流状态2")])]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": "process"
    }
  }, [_c('h3', [_vm._v("【城市】物流状态1")])]), _vm._v(" "), _c('mt-step', {
    attrs: {
      "status": "finish"
    }
  }, [_c('h3', [_vm._v("快件已发货")])])], 1), _vm._v(" "), _c('mt-button', {
    on: {
      "click": _vm.changeStatus
    }
  }, [_vm._v("第二步")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1007f224","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/steps.vue
// module id = 614
// module chunks = 0